import React from "react";

import { setupActions } from '../actions';
import { connect } from 'react-redux'

import Switch from "react-switch";
import { Spinner } from 'components/Icons/Spinner';
import { EvaluationCard } from '../components/EvaluationCard';
import {
  Row,
  Col,
  Button,
  CardBody, Card,
  Modal, ModalBody

} from "reactstrap";
import Select from "react-select"; 
import './Config.css';

var viewActions = require ('store/view.actions');

class EvaluationsConfig extends React.Component {

  componentDidMount() {
    this.props.setMainTitle("Configuración de Niveles", [] )
    this.props.getLevels (this.props.token, this.props.currentCalendarID, null) ;
  }

  constructor(props) {
    super(props);
    this.state = {
      subjectEditing : "",
      isSaving: false,
      modalOpen: false,
      currentEval: {}
    }
 }

 setCurrentEval( evaluation ) {
  this.props.startEdit(evaluation.evaluation_id)
  this.setState({currentEval: evaluation })
  this.setModalOpen(!this.state.modalOpen) ;

}

 setModalOpen ( st ) {
  this.setState({ modalOpen: st }) ;

}
 searchLevels( parentID, lvlID ) {
  this.props.getLevels (this.props.token, this.props.currentCalendarID, parentID, lvlID) ;
 }

 updateEval = ( levelID, evaluationID, data, id ) => {
  this.props.updateEvaluation ( this.props.token, levelID, evaluationID, data, id ) ;
};




  render() {
    return (
      <>
        <Modal toggle={() => this.setModalOpen(!this.state.modalOpen)} isOpen={this.state.modalOpen}  size="lg">
            <ModalBody >
                <EvaluationCard 
                    data={this.state.currentEval}
                    // courseEvals={this.props.courseEvals}
                    updateEval={this.updateEval}
                    createEval={this.props.createEvaluation}
                    // delEval={this.props.deleteCourseSubjectStudentsEvals}
                    token={this.props.token}
                    closeMe={this.setModalOpen.bind(this)}
                    /> 

            </ModalBody>
        </Modal>


        <div className="content">
          <Card>
            <CardBody>
              <Row>
                <Col md="4">
                  Seleccionar nivel: 
                  {this.props.topLevels.length>0&&
                  <Select
                    className="react-select h4 "
                    classNamePrefix="react-select"
                    name="topLevels"
                    onChange={(sel) => this.searchLevels( sel.value, 1) }
                    options={ this.props.topLevels }
                    placeholder="Seleccionar nivel"
                    isSearchable={false}
                    
                /> 
                  }
                  {this.props.subLevels.length>0&&
                  <Select
                    className="react-select h4 "
                    classNamePrefix="react-select"
                    name="subLevels"
                    onChange={(sel) => this.searchLevels( sel.value, 2) }
                    options={ this.props.subLevels }
                    placeholder="Seleccionar subnivel"
                    isSearchable={false}
                    
                /> 
                  }
                  {this.props.leaf.length>0&&
                  <Select
                    className="react-select h4 "
                    classNamePrefix="react-select"
                    name="leaf"
                    onChange={(sel) => this.props.getEvaluations ( this.props.token,  sel )  }
                    options={ this.props.leaf  }
                    placeholder="Seleccionar curso"
                    isSearchable={false}
                    
                /> 
                  }
                </Col>
              <Col md="8">
                <table class="subjects">
                    <thead>
                        <tr>
                            <td colspan="7" style={{fontSize: "20px"}}>Períodos evaluatorios del nivel
                            {this.props.view.loadingModules.getSubjectLevels ? <Spinner  /> : <> {this.props.level.name}</>} 
                            </td>
                        </tr>
                    </thead>
                    <tr>
                        <td width="25%">Nombre</td>
                        <td width="13%">Desde</td>
                        <td width="13%">Hasta</td>
                        <td width="13%">Tipo <br/>Calificación</td>
                        <td width="12%">Calificación<br/>cerrada</td>
                        <td width="12%">Visible <br/>al alumno</td>
                        <td width="12%">Acción</td>
                    </tr>
                    {!this.props.view.loadingModules.getEvaluations ?
                      this.props.evaluations.map( ev => {
                        
                      return (
                        <tr>
                          <td>{ev.name} ({ev.short_name})</td>
                          <td>{ev.start_date}</td>
                          <td>{ev.end_date }</td>
                          <td>{ev.evaluation_type }</td>
                          <td>
                              {this.props.view.loadingModules["updating_"+ev.evaluation_id+"block"]? 
                                                          <Spinner /> 
                                                        :                           
                                                        <Switch
                                                            onChange={() => {
                                                              this.updateEval( ev.level_id, ev.evaluation_id,  
                                                                             {blocked:(ev.blocked==="Y"?"N":"Y")}, "block") }
                                                                            }
                                                            checked={ev.blocked==="Y"} 
                                                            className="react-switch"
                                                            />
                              }
                            </td>
                            <td>
                              {this.props.view.loadingModules["updating_"+ev.evaluation_id+"visi"]? 
                                                          <Spinner /> 
                                                        :                           
                                                        <Switch
                                                            onChange={() => {
                                                              this.updateEval( ev.level_id, ev.evaluation_id,  
                                                                             {visible:(ev.visible==="Y"?"N":"Y")}, "visi") }
                                                                            }
                                                            checked={ev.visible==="Y"} 
                                                            className="react-switch"
                                                            />
                              }
                            </td>
                            <td>
                                   {this.props.view.loadingModules["updating_"+ev.evaluation_id+"edit"]? 
                                          <Spinner /> 
                                          :   
                                          <Button  size="sm" 
                                                    // color={action.type}  
                                                    onClick={() => this.setCurrentEval( ev )}>
                                                    Editar
                                                  </Button> 
                            }
                            </td>
                        </tr>
                      )
                    }):
                    <tr>
                            <td colspan="7"><Spinner size="XL"/></td>
                    </tr>
                    
                    
                    }
                     {this.props.level && this.props.level.level_id &&
                            <tr>
                              <td colspan="7">
                                  <Button  size="sm" 
                                          // color={action.type}  
                                          onClick={() => {  
                                                let newEv = {
                                                      level_id: this.props.level.level_id }

                                                this.setCurrentEval( newEv )
                                                }
                                          }>
                                          Crear nuevo período evaluatorio
                                        </Button> 
                              </td>
                            </tr>
                        }
                </table>
              </Col>
            </Row>
            </CardBody>
          </Card>
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        currentCalendarID:  state.school.currentCalendarID,
        token: state.auth.session.jwt_token,
        view: state.view,
        
        topLevels: state.setup.topLevels,
        subLevels: state.setup.subLevels,
        leaf: state.setup.leaf,
        level: state.setup.level,
        evaluations: state.setup.evaluations
     }
  }

  const mapDispatchToProps = dispatch => {
    return { 
        getLevels: (token, calendarID, parentID, lvlID) => {
          dispatch( setupActions.getLevels ( token, calendarID, parentID, lvlID ) );
        },
        getEvaluations: ( token, level )  => {
          dispatch( setupActions.getEvaluations (  token, level ) );
        },
        updateEvaluation: ( token, levelID, evaluationID, data, id  ) => {
          dispatch( setupActions.updateEvaluation (  token, levelID, evaluationID, data, id ) );

        },
        createEvaluation: ( token, data  ) => {
          dispatch( setupActions.createEvaluation (  token, data ) );
        },

        // deleteSubjectLevels: ( token, levelID, subjectID ) => {
        //   dispatch( setupActions.deleteSubjectLevels ( token, levelID, subjectID ) );
        // },
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        startEdit: (id) => {
          dispatch(viewActions.isLoadingModule('updating_' + id + "edit" ,true)) ;
        }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(EvaluationsConfig);

